export enum GoalType {
    'DELIVERY_ENGAGEMENT' = 6,
    'DELIVERY_VIEWABILITY' = 7,
    'ENGAGEMENT_CPCV' = 8,
    'VIEWABILITY_VCPM' = 9
}
